import React from "react";
import { IconDeviceFloppy } from "@tabler/icons-react";
import Modal from "./Modal";
import { useOrder } from "../../context/OrderContext";
import { useOrderSave } from "../../context/OrderSaveContext";

const NotesModal = ({ isOpen, onClose, readOnly}) => {
	const { order, updateOrder } = useOrder();
	const { saveOrder, loading } = useOrderSave();

	const handleNoteChange = (e) => {
		const newNote = e.target.value;
		updateOrder((prevOrder) => ({
			...prevOrder,
			hmeliorder: {
				...prevOrder.hmeliorder,
				hmeliorder_plus_note: newNote,
			},
		}));
	};

	const handleSave = async () => {
		const result = await saveOrder(order, 'NotesModal');
		// Csak sikeres mentés után zárjuk be a modal-t
		if (result && result.success === true) {
			onClose();
		}
	};

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			onConfirm={handleSave}
			title="Megjegyzés a rendeléshez"
			type="primary"
			confirmText="Mentés"
			cancelText="Bezárás"
			fullScreen={true}
			confirmDisabled={loading || readOnly}
			customWidth="90%"
		>
			<div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                <span style={{color: 'green'}}> Megjegyzéseket lehet felvenni a rendeléshez, tetszőleges szöveget, amit a rendelés felvételének lépései alatt mindvégig elér, módosíthat és menthet és a megrendelő lapon is szerepelni fog!</span>
				<textarea
					className="form-control"
					value={order.hmeliorder.hmeliorder_plus_note || ""}
					onChange={handleNoteChange}
					rows={15}
					style={{ flexGrow: 1 }}
					placeholder="Ide írhatja a megjegyzéseit..."
                    readOnly={readOnly}
				></textarea>
			</div>
		</Modal>
	);
};

export default NotesModal;
